let current = {};
/** Called ONCE by block-registry.gen.ts at its module init. Internal — not part of the package surface. */
export function registerDefaultBlockRegistry(registry) {
    current = registry;
}
/**
 * The registry BlockRenderer falls back to. Resolved at RENDER time, never at module-init time —
 * that late resolution is the whole point of this module.
 */
export function getDefaultBlockRegistry() {
    return current;
}
//# sourceMappingURL=default-registry.js.map